import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

i18next.use(initReactI18next).init({
  fallbackLng: 'English (UK)',
  interpolation: { escapeValue: true, prefix: '[', suffix: ']' },
});

export { i18next as i18n };
